
import {map} from 'rxjs/operators';
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {BlobId, DeviceId, VirtualPackageId, ProjectId, IntegrationId} from '../../types/ids';
import {AuthService} from "../../services/auth.service";
import {GenericApiResponse} from '../apibase.api';
import {
    VirtualPackage,
    packageFromBackendObject,
    ReleaseMetaInfo
} from '../../types/packages/package';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: "root"
})
export class PackageApi {

    constructor(private http: HttpClient, private auth: AuthService) {
    }

    getPackageById(packageId: VirtualPackageId): Observable<VirtualPackage> {
        return this.http.get<any>("/package/packages/" + packageId).pipe(map( response => packageFromBackendObject(response)));
    }

    getPackageIdsForProject(projectId: ProjectId): Observable<VirtualPackageId[]> {
        return this.http.get<Array<VirtualPackageId>>("/projects/" + projectId + "/packages");
    }

    getPackagesForProject(projectId: ProjectId): Observable<VirtualPackage[]> {
        return this.http.get<Array<any>>("/projects/" + projectId + "/packages/full").pipe(map( response => response.map(r => packageFromBackendObject(r))));
    }

    testPackageSourceConfig(config: any): Observable<any> {
        return this.http.post<any>("/package/packagesources/test-config", config);
    }

    createPackage(blobId: BlobId, projectId: ProjectId, name: string, extension: string): Observable<VirtualPackage> {
        let o = {
            name: name,
            blobId: blobId,
            extension: extension
        };

        return this.http.post<any>("/projects/" + projectId + "/packages", o).pipe(map(response => packageFromBackendObject(response)));
    }

    createPackageFromPackageSource(config: any, projectId: ProjectId, name: string): Observable<VirtualPackage> {
        let o = {
            name: name,
            packageSourceConfig: config,
        };

        return this.http.post<any>("/projects/" + projectId + "/packages?fromPackageSource", o).pipe(map(response => packageFromBackendObject(response)));
    }

    updatePackage(packageId: VirtualPackageId, blobId: BlobId, name: string, extension: string): Observable<VirtualPackage> {
        let o = {
            name: name,
            blobId: blobId,
            extension: extension
        };

        return this.http.put<any>("/package/packages/" + packageId, o).pipe(map(response => packageFromBackendObject(response)));
    }

    updatePackageMetaInfo$(packageId: VirtualPackageId, name: string): Observable<GenericApiResponse> {
        let o = {
            name: name,
        };

        return this.http.put<GenericApiResponse>("/package/packages/" + packageId + '/metainfo', o);
    }

    updatePackageFromPackageSource(packageId: VirtualPackageId, optRelease?: string): Observable<VirtualPackage> {
        let queryReleaseString = '';
        if (!!optRelease) {
            queryReleaseString = `&release=${optRelease}`;
        }

        return this.http
            .post<any>("/package/packages/" + packageId + "?updateFromPackageSource" + queryReleaseString, {})
            .pipe(map(response => packageFromBackendObject(response)));
    }

    deletePackage(packageId: VirtualPackageId): Observable<GenericApiResponse> {
        return this.http.delete<any>("/package/packages/" + packageId);
    }

    getReleasesForPackageRepositoryOfPackage(packageId: VirtualPackageId): Observable<Array<ReleaseMetaInfo>> {
        return this.http.get<Array<any>>(`/package/packages/${packageId}/reporeleases`);
    }

}
